import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@ionic/angular';
import { NavigationStart, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { Api } from '../smoothr-web-app-core/api/api';
import { NavigationService, NAVIGATIONURLS } from './services/navigation.service';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import { CookieConsentService } from './services/cookie.service';
import { BehaviorSubject, catchError, filter, Observable, of, switchMap } from 'rxjs';
import Order from 'src/smoothr-web-app-core/models/Order';
import { SwUpdate } from '@angular/service-worker';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
	standalone: false,
})
export class AppComponent implements OnInit {
	static isWebApp = true;
	static isNativeApp = false;
	isCookieAccepted = false;
	public trackAuthUrl$: Observable<{
		order: boolean;
		auth: boolean;
		home: boolean;
	}>;
	public order$ = new BehaviorSubject<Order | null>(null);

	constructor(
		private router: Router,
		platform: Platform,
		private navigationService: NavigationService,
		private cookieService: CookieConsentService,
		public translate: TranslateService,
		private repository: RepositoryService,
		private swUpdate: SwUpdate
	) {
		console.log(environment.customerGroup + ' ' + environment.version);
		const favIcon: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
		favIcon.type = 'image/x-icon';
		favIcon.rel = 'shortcut icon';
		favIcon.href = '/assets/topgolf/header_logo.svg';
		document.getElementsByTagName('head')[0].appendChild(favIcon);
		document.title = translate.instant('index.title.' + environment.customerGroup);

		this.handleCookieConsent();
		const languageValue = localStorage.getItem('langOfApp');
		console.log(languageValue);
		if (languageValue) {
			translate.setDefaultLang(languageValue);
			translate.use(languageValue);
		} else {
			translate.setDefaultLang('de');
			translate.use('de');
		}

		translate.onLangChange.subscribe(languageChanged => {
			if (languageChanged) localStorage.setItem('langOfApp', languageChanged.lang);
		});
		this.repository.observableOrder.subscribe(order => {
			this.order$.next(order);
		});
		this.trackAuthUrl$ = this.router.events.pipe(
			filter(event => event instanceof NavigationStart),
			switchMap((eventData: NavigationStart) =>
				of({
					auth: false,
					order: eventData?.url?.includes('/' + NAVIGATIONURLS.order()),
					home: eventData?.url?.includes(NAVIGATIONURLS.home()),
				})
			),
			catchError(e => {
				return of({
					order: false,
					auth: false,
					home: false,
					promo: false,
				});
			})
		);

		Api.isMaintenanceActive()
			.then(result => {
				if (result) {
					this.navigationService.maintenance();
				}
			})
			.catch(error => {
				console.log(error);
			});
	}

	ngOnInit() {
		if (!this.swUpdate.isEnabled) {
			return;
		}
		// Activate only; a forced reload could drop an order mid-checkout. The new
		// version takes over on the next page load.
		this.swUpdate.versionUpdates.pipe(filter(event => event.type === 'VERSION_READY')).subscribe(() => this.swUpdate.activateUpdate());
		// A broken cache cannot recover on its own, so this one does need a reload.
		this.swUpdate.unrecoverable.subscribe(() => document.location.reload());
	}

	ngDoCheck() {}

	private handleCookieConsent() {
		try {
			this.cookieService.initializeCookieConsent();
		} catch (e) {}
	}
}
